import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

export function initNews(query = document.querySelectorAll('.js-newsSlider')) {
    for (const el of query) {
        Swiper.use([Navigation]);
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 20,
            watchSlidesProgress: true,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                481: {
                    slidesPerView: "auto",
                    spaceBetween: 89,

                },

            },
        });
    }
}
